<script>
import LoginForm from "../components/auth/login_form.vue";

export default {
  name: "LoginView",
  components: {
    LoginForm,
  },
  computed: {
    isSessionExpired() {
      return this.$route.query.ref === "expired";
    },
  },
  created() {
    const redirectUrl = this.$route.query.redirect_url;
    if (!redirectUrl) {
      return;
    }
    try {
      const url = new URL(redirectUrl);
      if (
        url.protocol === "https:" &&
        (url.hostname === "clerk.accounts.dev" ||
          url.hostname.endsWith(".clerk.accounts.dev")) &&
        url.pathname.startsWith("/v1/verify")
      ) {
        window.location.href = url.toString();
      }
    } catch {
      // invalid URL — ignore
    }
  },
};
</script>

<template>
  <eg-b-container>
    <eg-b-row>
      <eg-b-col>
        <eg-b-alert v-if="isSessionExpired" variant="warning" show>{{
          $t("auth.sessionExpired")
        }}</eg-b-alert>

        <login-form />
      </eg-b-col>
    </eg-b-row>
  </eg-b-container>
</template>
